export default "__VITE_ASSET__ChqOVcsM__"